/**
 * Created by H
 * User: huangcan
 * Date: 2019-08-19
 * Time: 15:05
 * tips: 这个是记录拥有tab页的索引
 */
import { mapMutations } from 'vuex'

export default {
  created() {
    this._tabsRead()
  },
  methods: {
    ...mapMutations({
      tabsIndexRecord: 'CHANGE_TABS'
    }),
    /**
     * 将当前tab索引记录到store里面保存,重置页面和搜索条件
     * @param obj
     * @private
     */
    _tabsRecord(obj) {
      let data = {
        name: this.$route.name,
        currentIndex: this.activeName
      }
      if (obj) {
        data = { ...data, ...obj }
      }
      this.$nextTick(() => {
        const table = this.$refs.table
        const defaultSize = $table => {
          const pagination = $table.$refs.pagination
          if (pagination) {
            pagination.defaultSize()
          }
        }
        if (Array.isArray(table)) {
          table.forEach(v => {
            defaultSize(v)
          })
        } else {
          defaultSize(table)
        }
        if (this.pagination) {
          this.pagination.currentPage = 1
        }
        if (this.condition) {
          for (let key in this.condition) {
            this.condition[key] = ''
          }
        }
      })
      this.tabsIndexRecord(data)
    },

    /**
     * 读取store里面的tabs索引记录
     */
    _tabsRead() {
      const tabsActive = v => (this.activeName = v.currentIndex)
      this.$store.state.tabs.map(v => {
        const routeName = this.$route.name === v.name
        if (v.id && routeName) {
          if (v.id === this.$route.query.id || v.id === 0) {
            tabsActive(v)
          }
          return
        }
        if (routeName) {
          tabsActive(v)
        }
      })
    }
  }
}
